<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle1"><a id="page_iii">CONTENTS</a></p><a id="page_iii">
</a><p class="toc"><a id="page_iii"></a><span href="#/xhtml/01_Cover" title="Link target outside of Sample">Cover</span></p>
<p class="toc"><span href="#/xhtml/02_Title01" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/03_Copyright01" title="Link target outside of Sample">Copyright</span></p>
<p class="toc"><a href="#/xhtml/04_Contents">Contents</a></p>
<p class="toc"><a href="#/xhtml/05_Dedication">Dedication</a></p>
<p class="toc"><a href="#/xhtml/06_FM01">Authors’ Note</a></p>
<p class="toc"><a href="#/xhtml/06_FM01#epi">Epigraph</a></p>
<p class="toc"><a href="#/xhtml/07_Introduction">Introduction</a></p>
<p class="toc"><a href="#/xhtml/08_Part01">Part 1: Innocence</a></p>
<p class="toc"><a href="#/xhtml/09_Chapter01">Chapter 1</a></p>
<p class="toc"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc"><span href="#/xhtml/13_Part02" title="Link target outside of Sample">Part 2: Protection</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc"><span href="#/xhtml/18_Part03" title="Link target outside of Sample">Part 3: Disappearance</span></p>
<p class="toc"><span href="#/xhtml/19_Chapter09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc"><span href="#/xhtml/20_Chapter10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc"><span href="#/xhtml/21_Chapter11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc"><span href="#/xhtml/22_Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/23_Author" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/24_BM01" title="Link target outside of Sample">About the Feminist Press</span></p>
<p class="toc"><span href="#/xhtml/25_BM02" title="Link target outside of Sample">Also Available from the Feminist Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?1f35f1b5